export default __webpack_public_path__ + "static/media/257.d6a8b9cb.gif";